export function handelEnabled(key, page, genaralCustom) {
  if (page === "view") return true;
  let a = genaralCustom?.find((item) => item.value === key);
  console.log("handelEnabled", !a?.enabled);
  return !a?.enabled;
}

